import { isPlatform } from "@ionic/react";
import dayjs from "dayjs";
import { StorageService } from "./storage.service";
import { CONSTANTS } from "../constants";
import _ from "lodash";
import { CallService } from "../components/Shared/Call/Call.service";

var isPhoneReminderActive: any = undefined;
var phoneReminderData: any = {};
var intervalTime: any;

let getDeviceType = () => {
  let platform = "WEB";
  // if (isPlatform("ios") || isPlatform("android")) {
  //   platform = "NATIVE";
  // }
  return platform;
};

/**
 * Function to return the current time using dayjs
 */
let getCurrentTime = () => {
  const time = dayjs().format("HH:mm");
  return time;
};

let getFormattedCurrentTime = () => {
  const time = dayjs().format("hh:mm A");
  return time;
};

let getTimeOnly = (date: any) => {
  const time = dayjs(date).format("HH:mm");
  return time;
};

let getAMPMTimeOnly = (date: any) => {
  const time = dayjs(date).format("hh:mm A");
  if (time === "Invalid Date") {
    return date;
  } else {
    return time;
  }
};

let getTime12hrFormat = (InputTime: string) => {
  const time = dayjs(dayjs().format("YYYY-MM-DD") + "T" + InputTime).format(
    "hh:mm A"
  );
  return time;
};

let getDateAdded = (date: any) => {
  const today = dayjs(date).format("YYYY-MM-DD");
  return today;
};

let getCurrentDate = () => {
  const today = dayjs().format("YYYY-MM-DD");
  return today;
};

let addDaysToDate = (date: string, count: any) => {
  const today = new Date(date);
  const newdate = new Date(date);
  newdate.setDate(today.getDate() + count);
  return newdate;
};
let getMonthName = (date: string) => {
  const month = dayjs(date).format("MMM");
  return month;
};

let getDateLongFormat = (date: any) => {
  const month = dayjs(date).format("MMMM YYYY");
  return month;
};

let getUpdatedDateLongFormat = (date: any) => {
  if (date) {
    const month = dayjs(date).format("MMMM DD YYYY");
    return month;
  } else {
    return date;
  }
};

let getDayLongFormat = (date: any) => {
  const month = dayjs(date).format("MMMM DD, YYYY");
  return month;
};

let getDayFormat = (date: any) => {
  if (date) {
    const month = dayjs(date).format("MMMM DD, YYYY");
    return month;
  } else {
    const today = utilService.getCurrentDate();
    const month = dayjs(today).format("MMMM DD, YYYY");
    return month;
  }
};

let getPreviousMonth = (date: any) => {
  var makeDate = new Date(date);
  var month = new Date(makeDate.setMonth(makeDate.getMonth() - 1));
  return month;
};

let getPreviousDay = (date: any) => {
  const today = new Date(date);
  const prevDate = new Date(date);
  prevDate.setDate(today.getDate() - 1);
  return prevDate;
};

let getNextDay = (date: any) => {
  const today = new Date(date);
  const nexDate = new Date(date);
  nexDate.setDate(today.getDate() + 1);
  return nexDate;
};

let getNextMonth = (date: any) => {
  var makeDate = new Date(date);
  var month = new Date(makeDate.setMonth(makeDate.getMonth() + 1));
  return month;
};

let getCurrentDateAndTime = () => {
  const today = dayjs().format("MM/DD/YYYY hh:mm A");
  return today;
};

const getNetwork = () => {
  const savePassword = getSavePasswordStatus();
  const network = StorageService.getStorageItem(
    CONSTANTS.STORAGE[true === savePassword ? 1 : 0],
    "network",
    true
  );

  return network;
};

const getLoggedUserGuid = () => {
  const savePassword = getSavePasswordStatus();
  const guid = StorageService.getStorageItem(
    CONSTANTS.STORAGE[true === savePassword ? 1 : 0],
    "guid",
    true
  );

  return guid;
};

const getSavePasswordStatus = () => {
  const savePassword = StorageService.getStorageItem(
    localStorage,
    "savePassword"
  )
    ? JSON.parse(StorageService.getStorageItem(localStorage, "savePassword"))
    : undefined;

  return savePassword;
};

const getCurrentHour = () => {
  let currTime = dayjs();
  let hour = currTime.hour();
  return hour;
};

const getCurrentMinutes = () => {
  let currTime = dayjs();
  let minutes = currTime.minute();
  return minutes;
};
const getShortDate = (date: string) => {
  const fomattedDate = dayjs(date).format("MMM DD");
  return fomattedDate;
};

const getShortDateWithYear = (date: string) => {
  const fomattedDate = dayjs(date).format("MMM DD, YYYY   hh:mm A");
  return fomattedDate;
};
const getTime = (date: string, shift: string) => {
  const fomattedTime = dayjs(date + "T" + shift).format("hh:mm A");
  return fomattedTime;
};

const getFormattedDateTime = (dateTime: string) => {
  const fomattedDateTime = dayjs(dateTime).format("MMM D, hh:mm A");
  return fomattedDateTime; //Feb 5, 03:29 AM
};

const getDate = (date: string) => {
  const returnDate = dayjs(date.replace("+", "T") + ":00").format(
    "YYYY-MM-DD HH:mm:ss"
  );
  return returnDate;
};

const getDateFormat = (date: string) => {
  const returnDate = dayjs(date).format("YYYY-MM-DD HH:mm:ss");
  return returnDate;
};

const getScreenSize = () => {
  const screenWidth = +window.innerWidth;
  const screenType = screenWidth > 991 ? "large" : "small";
  return screenType;
};

const isEmpty = (obj: any) => {
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      return false;
    }
  }
  return true;
};

const findObjectIndex = (list: any[], obj: any, key: string): number => {
  return _.findIndex(list, (item) => {
    return key === item[obj];
  });
};

const findObject = (list: any[], key: any, value: any): number => {
  return _.find(list, (item) => {
    return item[key] === value;
  });
};
const dateFormat = (type: string) => {
  const date = type === "short" ? "MMM DD, YYYY" : "MMMM DD YYYY";
  return date;
};

const findObjectByQuery = (list: any[], key: string, query: string): any => {
  return _.find(list, (item) => {
    return item[key].toLowerCase() === query.toLowerCase();
  });
};

const removeObject = (list: any[], key: any, value: any) => {
  _.remove(list, (currentObject) => {
    return currentObject[key] === value;
  });
};

const arrayContains = (list: any, val: any) => {
  return _.some(list, (item) => {
    return _.isEqual(item, val);
  });
};

const checkUserRole = (roleToBeChecked: string): boolean => {
  let userRoles = StorageService.getStorageItem(
    CONSTANTS.STORAGE[true === getSavePasswordStatus() ? 1 : 0],
    "roles",
    true
  );
  userRoles = userRoles && JSON.parse(userRoles);
  return findObjectIndex(userRoles, "name", roleToBeChecked) === -1
    ? false
    : true;
};

const checkIfInputEmpty = (elementId: string) => {
  const inputField = document.getElementById(elementId);
  const isWhitespace = (inputField?.textContent || "").trim().length === 0;
  return isWhitespace;
};

const formatSpeciality = (value: string) => {
  return value && value.split(/-(.+)/).length > 1
    ? value.split(/-(.+)/)[1]
    : value;
};

const getFullDate = (date: string) => {
  const returnDate = dayjs(date).format("YYYY-MM-DD HH:mm:ss");
  return returnDate;
};

const constructFormData = (formValue: any) => {
  const formData = new FormData();
  for (const key of Object.keys(formValue)) {
    const value = formValue[key];
    formData.append(key, value);
  }
  return formData;
};

const updateDisplayButtonList = (
  divRow: any,
  cardDetails: any,
  requiredCardPadding: any,
  cardType: any
) => {
  const divData =
    cardType === CONSTANTS.STATUS_BOARD_ROWTYPE.CARE_TEAM
      ? divRow && divRow.children && divRow.children.length > 0
        ? divRow.children[0]
        : undefined
      : divRow && divRow.children && divRow.children.length > 0
        ? divRow.children[0]
        : undefined;
  const isWidthKeyPresent = divRow && divRow.offsetWidth ? true : false;
  if (isWidthKeyPresent) {
    const rowWidth = divRow.offsetWidth;
    const dataSet = setDisplayListsBasedOnWidthCalculation(
      rowWidth,
      divData,
      requiredCardPadding,
      cardDetails
    );
    return dataSet;
  }
};

const setCapabilityTokenForIncomingCall = async () => {
  const params = {
    guid: getLoggedUserGuid(),
    reg_code: getNetwork(),
  };
  const res: any = await CallService.getCapabilityTokenInformation(params);
  if (res.isSuccess && res.message) {
    sessionStorage.setItem("capToken", res.result);
    return res.result;
  }
};

const setDisplayListsBasedOnWidthCalculation = (
  rowWidth: any,
  divRow: any,
  requiredCardPadding: any,
  cardDetails: any
) => {
  let isMoreRequired = false;
  let result: any = {};
  if (divRow) {
    let childSelector;
    let totalButtonWidth = 0;
    const initalPadding = 25;
    const cardPadding = requiredCardPadding;
    let buttonWidth = initalPadding;
    // tslint:disable-next-line:prefer-for-of
    for (let ind = 0; ind < divRow.children.length; ind++) {
      if (!isMoreRequired) {
        childSelector = divRow.children[ind];
        buttonWidth = childSelector.offsetWidth + cardPadding;
        if (totalButtonWidth + buttonWidth <= rowWidth) {
          totalButtonWidth = totalButtonWidth + buttonWidth;
        } else {
          result = setListValues(ind, cardDetails);
          isMoreRequired = result.isMoreRequired;
        }
      }
    }
  }
  return result;
};

const setListValues = (ind: any, cardDetails: any) => {
  const displayedButtonList = cardDetails.splice(0, ind);
  const hiddenButtonList = cardDetails;
  const isMoreRequired = hiddenButtonList.length > 0 ? true : false;
  return { displayedButtonList, hiddenButtonList, isMoreRequired };
};

const formatBytes = (bytes: any, decimals = 2) => {
  var sizeInMB = (bytes / (1024 * 1024)).toFixed(3);
  return sizeInMB;
};

const isWeb = () => {
  let platform = true;
  if (isPlatform("ios") || isPlatform("android")) {
    platform = false;
  }
  return platform;
};

let getFirstDayOfTheMonth = (date: any) => {
  var currentDate = new Date(date);
  var firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
  return firstDay;
};

const setAlarmTimeOut = (intervalTime: any) => {
  //   dataTransfer.setPhoneReminderAlarm(intervalTime);
};

const getTimerList = () => {
  if (isPhoneReminderActive === undefined && getLoggedUserGuid()) {
    isPhoneReminderActive = true;
    // dataTransfer.setPhoneReminder('');
  }
  if (
    phoneReminderData["time"] !== undefined &&
    !dayjs(phoneReminderData["time"]).isAfter
  ) {
    setAlarmTimeOut(3000);
  }
};

const hideFooterTab = () => {
  const innerWidth = Number(window.innerWidth);
  const screenSize = innerWidth > 899 ? "large" : "small";
  if (screenSize === "small") {
    const element = document.getElementById("tabFooter");
    if (element) {
      element.setAttribute("style", "display:none");
    }
  }
};

const showFooterTab = () => {
  const innerWidth = Number(window.innerWidth);
  const screenSize = innerWidth > 899 ? "large" : "small";
  if (screenSize === "small") {
    const element = document.getElementById("tabFooter");
    if (element) {
      element.setAttribute("style", "display:block");
    }
  }
};
const getProfilePicUrl = (userPic: any) => {
  const profile_pic =
    userPic && userPic.substring(0, 7) === "/media/"
      ? userPic
      : userPic && userPic.indexOf("/media/") !== -1
        ? userPic.substr(userPic.indexOf("/media/"))
        : undefined;
  return profile_pic;
};
const getBaseUrl = () => {
return(window as any)._env_?.REACT_APP_API_BASEURL;
};

let getDateAndTime = (date: any) => {
  const today = dayjs(date).format("YYYY-MM-DD hh:mm A");
  return today;
};

  
//convert string to array 'a,b' => ['a','b']
const parseStringToArray = (value?: string): string[] => {
  return value?.split(',').map(item => item?.trim()).filter(Boolean) || [];
};

export const utilService = {
  getNetwork,
  getDeviceType,
  getCurrentTime,
  getCurrentDate,
  getLoggedUserGuid,
  getSavePasswordStatus,
  getCurrentHour,
  getCurrentMinutes,
  getDate,
  getScreenSize,
  getShortDate,
  getTime,
  isEmpty,
  findObjectIndex,
  findObject,
  findObjectByQuery,
  removeObject,
  arrayContains,
  dateFormat,
  getFormattedDateTime,
  checkUserRole,
  checkIfInputEmpty,
  formatSpeciality,
  // formatTime,
  getFullDate,
  getCurrentDateAndTime,
  updateDisplayButtonList,
  formatBytes,
  constructFormData,
  getTime12hrFormat,
  addDaysToDate,
  getDateAdded,
  getMonthName,
  getDateLongFormat,
  getDayLongFormat,
  getDayFormat,
  getUpdatedDateLongFormat,
  getPreviousMonth,
  getNextMonth,
  getPreviousDay,
  getNextDay,
  isWeb,
  getFirstDayOfTheMonth,
  setAlarmTimeOut,
  getTimerList,
  isPhoneReminderActive,
  phoneReminderData,
  intervalTime,
  getTimeOnly,
  hideFooterTab,
  showFooterTab,
  getProfilePicUrl,
  setCapabilityTokenForIncomingCall,
  getBaseUrl,
  getDateAndTime,
  getShortDateWithYear,
  getFormattedCurrentTime,
  getAMPMTimeOnly,
  getDateFormat,
  parseStringToArray
};
